import { css } from 'styled-components';
import { LoaderContainer } from 'modules/v2/feedback/Loader/styled';
import { pxToRem } from '../../foundation/spacing';
const TYPOGRAPHY_SIZE_MAP = {
    small: 'tiny',
    medium: 'small',
    large: 'medium',
};
export const getTypographySize = (size) => TYPOGRAPHY_SIZE_MAP[size];
export const getIconSize = (size) => {
    switch (size) {
        case 'large':
            return css `
        height: ${pxToRem(16)};
        width: ${pxToRem(16)};
      `;
        case 'small':
        case 'medium':
        default:
            return css `
        height: ${pxToRem(12)};
        width: ${pxToRem(12)};
      `;
    }
};
export const getContainerSize = (size) => {
    switch (size) {
        case 'large':
            return css `
        height: ${pxToRem(32)};
      `;
        case 'small':
            return css `
        height: ${pxToRem(20)};
      `;
        case 'medium':
        default:
            return css `
        height: ${pxToRem(24)};
      `;
    }
};
export const getContentContainerPadding = (size) => {
    switch (size) {
        case 'large':
            return css `
        padding: 0 ${pxToRem(8)};
      `;
        case 'small':
            return css `
        padding: 0 ${pxToRem(6)};
      `;
        case 'medium':
        default:
            return css `
        padding: 0 ${pxToRem(8)};
      `;
    }
};
export const getChipActionPadding = (size) => {
    switch (size) {
        case 'large':
            return css `
        padding: ${pxToRem(10)} ${pxToRem(10)} ${pxToRem(10)} ${pxToRem(6)};
      `;
        case 'small':
            return css `
        padding: ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(2)};
      `;
        case 'medium':
        default:
            return css `
        padding: ${pxToRem(6)} ${pxToRem(6)} ${pxToRem(6)} ${pxToRem(4)};
      `;
    }
};
const LOADER_SIZE_MAP = {
    small: 12,
    medium: 14,
    large: 16,
};
export function getLoaderSize(size) {
    return css `
    ${LoaderContainer} {
      width: ${pxToRem(LOADER_SIZE_MAP[size])};
      height: ${pxToRem(LOADER_SIZE_MAP[size])};
    }
  `;
}
